<!--
 * @Description:
 * @Author: 王赵坤
 * @Date: 2023-11-21 09:54:15
 * @LastEditors: 王赵坤
 * @LastEditTime: 2023-11-21 11:18:16
-->
<template>
  <el-dialog :title="statusobj.teacher.realname" :visible.sync="dialogVisible" width="860px" :before-close="openEdit" :close-on-click-modal="false">
    <div class="boxmessage">
      <div class="box-body">
        <div class="box-body-rigth">
          <div v-loading="spinning" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" style="width: 100%;height: 100%;" v-if="statusobj.teacher_id">
            <div class="box-body-rigth-message" ref="scrollWrapper">
              <div v-for="item in messgeinforlist" :key="item.id">
                <div class="box-body-rigth-li" v-if="item.teacher_id==item.author_id">
                  <img :src=" item.teacher.head_img" alt="" v-if="item.teacher.head_img!=''">
                  <img src="../../../static/img2/nlstx.png" alt="" v-else>
                  <div>
                    <span>
                      {{ item.message }}
                    </span>
                  </div>
                  <span style="margin: 10px;" v-if="item.icon">
                    <i class="el-icon-loading"></i>
                  </span>
                </div>
                <div class="box-body-rigth-lileft" v-if="item.student_id==item.author_id">
                  <img :src="item.student.head_img" v-if="item.student.head_img!=''" alt="">
                  <img src="../../../static/img2/tx.png" alt="" v-else>
                  <div>
                    <span>
                      {{ item.message }}
                    </span>
                  </div>
                  <span style="margin: 10px;" v-if="item.icon">
                    <i class="el-icon-loading"></i>
                  </span>
                </div>
              </div>
            </div>
            <div class="box-body-rigth-bottom">
              <div class="box-body-rigth-bottom-text">
                <div class="bottom-text-input">
                  <!-- <a-textarea v-model:value="ruleForm.picture" placeholder="这里输入回复内容～" :auto-size="{ minRows: 2, maxRows: 5 }" /> -->
                  <el-input type="textarea" :rows="2" placeholder="这里输入回复内容～" v-model="ruleForm.picture"></el-input>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="CommentOutlined">
            <i class="el-icon-chat-dot-square"></i>
          </div> -->
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <!-- <el-button @click="openEdit()">取 消</el-button>
      <el-button type="primary" @click="submit()">确 定</el-button> -->
      <div></div>
      <div class="buttom-btn">
        <div @click="openEdit()">
          取 消
        </div>
        <div @click="submit()">
          确 定
        </div>
      </div>
    </div>
  </el-dialog>

</template>

<script>
export default {
  name: 'message',
  props: ['dialogVisiblemess', 'row'],
  data() {
    return {
      dialogVisible: false,
      ruleForm: {
        picture: '',
      },
      scrollWrapper: null, //滚动条
      timeInter: null, //定时器
      timemessage: null,
      statusobj: {}, //点击了学生信息
      spinning: false,
      messgeinforlist: [], //信息详情
      infordata: this.$store.getters.getUserInfo, //用户信息详情
    }
  },
  watch: {
    dialogVisiblemess: function (newV, oldV) {
      this.messgeinforlist = []
      this.dialogVisible = this.dialogVisiblemess
      console.log(this.infordata)
      let obj = {
        message: '',
        teacher: {
          realname: this.row.realname,
          head_img: this.row.head_img,
        },
        teacher_id: this.row.id,
      }
      this.statusobj = obj
      this.getmessgeinfor()
    },
  },
  methods: {
    // 控制滚动条滚动到底部
    scrollToBottom() {
      setTimeout(() => {
        const wrapper = this.$refs.scrollWrapper
        wrapper.scrollTop = wrapper.scrollHeight
      }, 10)
    },
    // 发送
    submit() {
      if (!/^\s+$/.test(this.ruleForm.picture) && this.ruleForm.picture != '') {
        let obj = {
          teacher_id: this.statusobj.teacher_id,
          message: this.ruleForm.picture,
        }
        let listobj = {
          student_id: this.infordata.id,
          author_id: this.infordata.id,
          student: {
            head_img: this.infordata.head_img,
          },
          message: this.ruleForm.picture,
          icon: true,
        }
        this.messgeinforlist.push(listobj)
        this.scrollToBottom();
        this.$http.addmessage(obj).then((res) => {
          console.log(res)
          this.ruleForm.picture=''
          this.getmessgeinfor()
        })
      } else {
        this.$message({
          message: '请输入内容！',
          type: 'warning',
        })
      }
    },
    // 选择了教师
    setstatusobj(e) {
      this.spinning = true
      this.statusobj = e
      this.getmessgeinfor()
    },
    openEdit() {
      this.statusobj = {}
      this.$emit('lcclick')
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          this.openEdit()
        })
        .catch((_) => {})
    },
    // 消息详情
    getmessgeinfor() {
      let obj = {
        teacher_id: this.statusobj.teacher_id,
      }
      this.$http.messageinfo(obj).then((res) => {
        console.log(res)
        this.spinning = false
        this.messgeinforlist = res.data
        this.scrollToBottom();
      })
    },
  },
  mounted() {},
  created() {},
}
</script>

<style lang="less" scoped>
.dialog-footer{
  display: flex;
  justify-content: space-between;
  padding-bottom: 10px;
}
.buttom-btn{
  display: flex;
  width: 160px;
  justify-content: space-around;
  margin-right: 10px;
  :nth-child(1){
    width: 70px;
    height: 35px;
    text-align: center;
    line-height: 35px;
    border: 1px solid #dcdfe6;
    color: #606266;
    border-radius: 5px;
    cursor:pointer
  }
  :nth-child(1):hover{
    width: 70px;
    height: 35px;
    text-align: center;
    line-height: 35px;
    border: 1px solid #dcdfe6;
    color: #606266;
    border-radius: 5px;
    border-color: #b3d8ff;
    color: #409eff;
    background: #ecf5ff;
    cursor:pointer
  }
  :nth-child(2){
    width: 70px;
    height: 35px;
    background-color: #979797;
    text-align: center;
    line-height: 35px;
    border-radius: 5px;
    background-color: #409eff;
    border-color: #409eff;
    color: #fff;
    cursor:pointer
  }
  :nth-child(2):hover{
    width: 70px;
    height: 35px;
    background-color: #979797;
    text-align: center;
    line-height: 35px;
    border-radius: 5px;
    background-color: #a0cfff;
    border-color: #409eff;
    color: #fff;
    cursor:pointer
  }
}
/deep/.el-dialog__body {
  padding: 0px 20px 20px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
  /* margin-left: 88px; */
  height: 650px;
}
.box-body-left::-webkit-scrollbar {
  width: 4px;
  background-color: #b0b0b0;
}

.box-body-left:hover ::-webkit-scrollbar-track-piece {
  /*鼠标移动上去再显示滚动条*/
  background-color: #b0b0b0;
  /* 滚动条的背景颜色 */
  border-radius: 6px;
  /* 滚动条的圆角宽度 */
}

.box-body-left:hover::-webkit-scrollbar-thumb:hover {
  background-color: #c0cecc;
}

.box-body-left:hover::-webkit-scrollbar-thumb:vertical {
  background-color: #c0cedc;
  border-radius: 6px;
  outline: 2px solid #b0b0b0;
  outline-offset: -2px;
  border: 2px solid #b0b0b0;
}
.box-body-rigth-message::-webkit-scrollbar {
  width: 4px;
  background-color: #b0b0b0;
}

.box-body-rigth-message:hover ::-webkit-scrollbar-track-piece {
  /*鼠标移动上去再显示滚动条*/
  background-color: #b0b0b0;
  /* 滚动条的背景颜色 */
  border-radius: 6px;
  /* 滚动条的圆角宽度 */
}

.box-body-rigth-message:hover::-webkit-scrollbar-thumb:hover {
  background-color: #c0cecc;
}

.box-body-rigth-message:hover::-webkit-scrollbar-thumb:vertical {
  background-color: #c0cedc;
  border-radius: 6px;
  outline: 2px solid #b0b0b0;
  outline-offset: -2px;
  border: 2px solid #b0b0b0;
}
:deep .ant-select:not(.ant-select-customize-input) .ant-select-selector {
  line-height: 30px;
}
// 滚动条宽度
div::-webkit-scrollbar {
  width: 4px;
}
// 滚动条轨道
div::-webkit-scrollbar-track {
  background: #f5f5f5;
  border-radius: 2px;
}
// 小滑块
div::-webkit-scrollbar-thumb {
  background: #f5f5f5;
  border-radius: 10px;
}
div::-webkit-scrollbar-thumb:hover {
  background: #f5f5f5;
}
.boxmessage {
  width: 820px;
  display: flex;
  justify-content: center;
  border: #dfdfdf 1px solid;
  .box-body {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    .box-body-rigth {
      width: 810px;
      height: 640px;
      padding: 10px;
      background-color: #f5f5f5;
      .CommentOutlined {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        .el-icon-chat-dot-square {
          font-size: 50px;
          color: #979797;
        }
      }
      // border: 1px solid #f56c6c;
      .box-body-rigth-message {
        width: 100%;
        height: 550px;
        overflow-y: auto;
        padding-right: 10px;
        padding-bottom: 10px;
        // overflow: hidden;
      }
      .box-body-rigth-bottom {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-top: 1px solid #c4c4c4;
        .box-body-rigth-bottom-text {
          display: flex;
          align-items: center;
          justify-content: space-evenly;
          width: 100%;
          .bottom-text-input {
            width: 600px;
            margin-top: 10px;
          }
          .bottom-text-btn {
            width: 100px;
            margin-top: 10px;
          }
        }
      }
      .box-body-rigth-li {
        width: 100%;
        display: flex;
        margin-top: 10px;
        img {
          width: 50px;
          height: 50px;
          border-radius: 5px;
        }
        div {
          max-width: 460px;
          word-wrap: break-word;
          position: relative;
          margin-left: 20px;
          background-color: #fff;
          border-radius: 5px;
          padding: 10px;
          color: black;
        }
        div:before {
          width: 0px;
          height: 0px;
          content: '';
          border-top: 10px solid transparent;
          border-bottom: 5px solid transparent;
          border-right: 10px solid #fff;
          position: absolute;
          top: 10px;
          left: -10px;
        }
      }
      .box-body-rigth-lileft {
        width: 100%;
        display: flex;
        flex-direction: row-reverse;
        margin-top: 10px;
        img {
          width: 50px;
          height: 50px;
          border-radius: 5px;
        }
        div {
          max-width: 460px;
          word-wrap: break-word;
          position: relative;
          margin-right: 20px;
          background-color: #e8f3fe;
          border-radius: 5px;
          padding: 10px;
        }
        div:before {
          width: 0px;
          height: 0px;
          content: '';
          border-top: 10px solid transparent;
          border-bottom: 5px solid transparent;
          border-left: 10px solid #e8f3fe;
          position: absolute;
          top: 10px;
          right: -10px;
        }
      }
    }
  }
}
.box-body-left {
  width: 260px;
  height: 640px;
  overflow-y: auto;
  // border: 1px solid #f56c6c;
  .box-body-left-li {
    padding: 5px 0 5px 0;
    background-color: #e4e4e4;
    padding: 5px;
    display: flex;
    cursor: pointer;
    img {
      width: 50px;
      height: 50px;
      border-radius: 5px;
    }
    div {
      display: flex;
      flex-direction: column;
      :nth-child(1) {
        margin-left: 10px;
        color: black;
        font-size: 14px;
      }
      :nth-child(2) {
        margin-left: 10px;
        color: #979797;
        font-size: 14px;
      }
    }
  }
  .box-body-left-li-true {
    padding: 5px 0 5px 0;
    background-color: #c5c5c5;
    padding: 5px;
    display: flex;
    cursor: pointer;
    img {
      width: 50px;
      height: 50px;
      border-radius: 5px;
    }
    div {
      display: flex;
      flex-direction: column;
      // width: 600px;
      :nth-child(1) {
        margin-left: 10px;
        color: black;
        font-size: 14px;
      }
      :nth-child(2) {
        margin-left: 10px;
        color: #979797;
        font-size: 14px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/User/teachmessage.vue